import styled from "styled-components";

export const BarraFiltrosContainer = styled.div`
  position: fixed;
  top: 0;
  ${({ showFiltros }) => (showFiltros ? `right: 0; ` : "right: -100%; ")}
  transition: top 0.6s ease, right 0.6s ease;
  width: 340px;
  height: 100vh;
  height: 100dvh;
  background: linear-gradient(257.94deg, #027bc0 18.65%, #004b76 86.55%);
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 34px;
`;
export const BarraFiltrosHeader = styled.div`
  span {
    color: var(--color-white);
    font-size: 28px;
    font-weight: 700;
  }
`;
export const BarraFiltrosBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 48px 0;
`;
export const BarraFiltrosFooter = styled.div``;
export const BarraFiltrosBtn = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 132px;
  height: 36px;
  border-radius: 8px;
  background-color: var(--color-broccoli);
  color: var(--color-white);
`;
